import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#044c92"
    }
  },
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: "#044c92",
        color: "white"
      }
    },
    MuiStepper: {
      root: {
        backgroundColor: "transparent"
      }
    },
    MuiButton: {
      root: {
        textTransform: "none"
      }
    }
  }
});

export default theme;
